import { useEffect } from 'react'

import { deleteMachine } from '@/apis/machines'
import MachinesPageHeader from '@/components/pages/Machines/List/PageHeader'
import MachinesTable from '@/components/pages/Machines/List/Table'
import { Machine } from '@/types'

import { useMachines } from './Machine.hooks'

const Machines = () => {
  const { getMachinesLoading, getMachinesResponse, getMachines } = useMachines()

  const handleDeleteMachine = async (id: Machine['id']) => {
    await deleteMachine({ id })
    getMachines()
  }

  useEffect(() => {
    getMachines()
  }, [getMachines])

  return (
    <>
      <MachinesPageHeader />
      <MachinesTable
        {...{
          dataSource: getMachinesResponse,
          getMachinesLoading,
        }}
        onDelete={handleDeleteMachine}
      />
    </>
  )
}

Machines.displayName = 'Machines'
export default Machines
